// extracted by mini-css-extract-plugin
export default {"icons":"NavCard_icons__eKZiZ","cardText":"NavCard_cardText__-hPve","data-grid":"NavCard_data-grid__RY5oH","cell":"NavCard_cell__g9YCI"};